import { gql } from '@apollo/client';

/**
 * Мутации колокольчика (ТЗ 0068).
 *
 * Каждая возвращает свежий `summary`: бейдж обязан обновиться тем же числом,
 * которое отдаёт опрос, и без второго запроса — иначе между «прочитал» и
 * следующим опросом он показывал бы старое.
 */
export const MarkNotificationsReadMutation = gql`
  mutation MarkNotificationsRead($ids: [ID!]!) {
    markStaffNotificationsRead(ids: $ids) {
      success
      customErrors {
        field
        message
        code
      }
      summary {
        unreadCount
        totalCount
        soundAlarm {
          active
          taskId
          title
        }
      }
    }
  }
`;

/**
 * `before` — не украшение: между отрисовкой попапа и кликом помещается новое
 * уведомление, и без границы по времени оно погасло бы непрочитанным.
 */
export const MarkAllNotificationsReadMutation = gql`
  mutation MarkAllNotificationsRead($before: DateTime) {
    markAllStaffNotificationsRead(before: $before) {
      success
      customErrors {
        field
        message
        code
      }
      summary {
        unreadCount
        totalCount
        soundAlarm {
          active
          taskId
          title
        }
      }
    }
  }
`;

export const SaveNotificationPrefsMutation = gql`
  mutation SaveNotificationPrefs($input: StaffNotificationSettingsInput!) {
    updateStaffNotificationSettings(input: $input) {
      success
      customErrors {
        field
        message
        code
      }
      settings {
        soundEnabled
        pollSeconds
        repeatAfterMinutes
        quietFrom
        quietTo
        enabledKinds
        availableKinds {
          key
          label
          enabled
        }
        telegramEnabled
        telegramLinked
        telegramUsername
        telegramLinkedAt
        telegramBlockedAt
        telegramAvailable
        robotRules
        availableRobotRules {
          key
          label
          enabled
          available
        }
      }
    }
  }
`;

export const StartTelegramLinkMutation = gql`
  mutation StartTelegramLink {
    startTelegramLink {
      success
      customErrors {
        field
        message
        code
      }
      link {
        deepLink
        expiresAt
      }
    }
  }
`;

export const DropTelegramLinkMutation = gql`
  mutation DropTelegramLink {
    unlinkTelegram {
      success
      customErrors {
        field
        message
        code
      }
      settings {
        telegramEnabled
        telegramLinked
        telegramUsername
        telegramLinkedAt
        telegramBlockedAt
        telegramAvailable
      }
    }
  }
`;
